import { React, ts } from '_core';

import Chart from './chart';

type OptimizedAlphaBiasStatisticsProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  title: string;
  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  context?: ts.types.signal.SignalAnalysisContext;
  widgetPaths: Record<'optimized_alpha_model_bias_statistics', string>;
};

const OptimizedAlphaBiasStatistics = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  fullScreen,
  widgetPaths,
  title,
}: OptimizedAlphaBiasStatisticsProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      fullScreen={fullScreen}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['optimized_alpha_model_bias_statistics']}
      title={title}
    />
  );
};

export default OptimizedAlphaBiasStatistics;
